import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-field-error',
  templateUrl: './form-field-error.component.html',
  styleUrls: ['./form-field-error.component.scss'],
  standalone: true,
  imports: [
    CommonModule
  ]
})
export class FormFieldErrorComponent {

  @Input("control") control: any;

}
